const { getConfigurationsByIds } = require('./get-by-ids')

exports.getByServiceId = function (state, id, params) {
  return getConfigurationsByIds(state, [`configuration:${id}`], params)
    .then(configurations => configurations[0])
}
